
/* Dotted ring with a pulsing green node */
function DottedRing({ className = "" }) {
  const N = 72;
  const R = 46;
  return (
    <svg viewBox="0 0 100 100" className={className} aria-hidden="true" data-testid="hero-dotted-ring">
      <g style={{ transformOrigin: "50px 50px", animation: "spin-slow 60s linear infinite" }}>
        {Array.from({ length: N }, (_, i) => {
          const a = (i / N) * Math.PI * 2;
          const on = i % 9 === 0;
          return (
            <circle
              key={i}
              cx={50 + Math.cos(a) * R}
              cy={50 + Math.sin(a) * R}
              r={on ? 0.9 : 0.45}
              fill={on ? "#0F0F0F" : "#9a9890"}
              opacity={on ? 0.8 : 0.5}
            />
          );
        })}
      </g>
      <circle
        cx={50 + R}
        cy={50}
        r="2.2"
        fill="#1E4D38"
        style={{ transformOrigin: "50px 50px", animation: "spin-slow 24s linear infinite" }}
      />
      <circle
        cx={50 + R}
        cy={50}
        r="5"
        fill="none"
        stroke="#1E4D38"
        strokeOpacity="0.35"
        strokeWidth="0.4"
        style={{ transformOrigin: "50px 50px", animation: "spin-slow 24s linear infinite" }}
      />
    </svg>
  );
}

export function HeroWave() {
  return (
    <div className="relative h-[320px] md:h-[440px] lg:h-[560px]" data-testid="hero-wave-visual">
      {/* ambient glow */}
      <div
        className="absolute right-[8%] top-[30%] w-[26rem] h-[26rem] rounded-full bg-[#1E4D38]/10 blur-[110px] pointer-events-none"
        aria-hidden="true"
      />
      <DottedRing className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-52 md:w-72 lg:w-80 opacity-90" />
    </div>
  );
}
